<template>
	<div class="form-group flex" :class="{ 'flex-col': true }" @click="$emit('click', $event)" :title="$t('mileage')">
		<div class="w-full flex justify-between" v-if="label" :class="{ 'cursor-pointer': false }">
			<label class="mb-0">
				{{ label }} <span v-if="sublabel" class="text-gray-500 flex-shrink-0 break-words leading-none text-sm">{{ sublabel }}</span>
				<span v-if="required" class="text-red-600 font-bold"> *</span>
			</label>
			<div
				class="flex rounded-full h-6 w-6 justify-center cursor-pointer"
				style="background-color: lightgrey; align-items: center"
				@click="$emit('revision')"
			>
				<font-awesome-icon :icon="['fas', 'redo']" class="flex justify-center text-connectProBlue" style="align-content: center; font-size: 13px" />
			</div>
		</div>
		<currency-input
			v-model="model"
			:currency="null"
			:disabled="disabled"
			maxlength="6"
			:placeholder="getPlaceholder"
			:precision="precision"
			:tabindex="tabIndex"
			:value-range="valueRange"
			class="shadow-md base-input"
			type="text"
			@change="change"
		/>
		<div class="input-errors" v-if="!isValid && !disabled">
			{{ errorMessage }}
		</div>
		<div v-if="lastValue != null" style="font-size: 13px">
			{{ $t('last_change', { kilometrage: new Intl.NumberFormat('de-DE').format(lastValue.kilometrage), date: getGermanDate(lastValue.created) }) }}
		</div>
	</div>
</template>

<script>
import { getGermanDate } from '@/plugins/Utils';

export default {
	name: 'BaseInputKilometrage',
	components: {},
	inheritAttrs: false,
	props: {
		label: {},
		required: {},
		value: {},
		valueRange: { default: undefined },
		maxLength: {},
		precision: { default: 0, type: Number },
		suffix: { default: '', type: String },
		minNumber: { default: null },
		sublabel: { default: null },
		validation: { default: null },
		tabIndex: { default: 0 },
		disabled: { type: Boolean, default: false },
		placeholder: {},
		baseInputClass: { default: '' },
		lastValue: { default: null },
	},
	mounted() {
		this.model = this.lastValue.kilometrage;
	},
	computed: {
		getPlaceholder() {
			return this.placeholder || this.label;
		},
		model: {
			get() {
				if (isNaN(this.value) || this.value === null) return null;
				return this.value / Math.pow(10, this.precision);
			},
			set(v) {
				this.$emit(
					'input',
					parseFloat(v)
						.toFixed(this.precision)
						.replaceAll('.', '')
						.replaceAll(',', ''),
				);
			},
		},
	},
	data() {
		return {
			isValid: true,
			errorMessage: {},
		};
	},
	methods: {
		getGermanDate,
		blur() {
			this.validate();
			this.$emit('blur');
		},
		change($event) {
			this.$emit('change', $event);

			if (this.valueRange) {
				const isBiggerThanMax = $event > this.valueRange?.max;
				const isSmallerThanMin = $event < this.valueRange?.min;
				if (isSmallerThanMin || isBiggerThanMax) {
					let text = '';
					if (isSmallerThanMin) {
						text = this.$t('input_updated_to_min').toString();
					} else {
						text = this.$t('input_updated_to_max').toString();
					}

					this.$swal(this.$t('general.attention').toString(), text, 'warning');
				}
			}
		},
		validate() {
			let isValid = true;
			if (!this.isDisabled) {
				const validation = this.validation;
				if (isValid && this.required) {
					isValid = isValid && this.value != null && this.value.length !== 0;
				}
				if (this.value === '') {
					this.errorMessage = this.$t('km_smaller_one_hint');
					isValid = false;
				}

				if (this.required && isNaN(this.model)) {
					isValid = false;
				}

				if (typeof validation === 'function') {
					isValid = isValid && validation(this.value);
				} else if (isValid && validation && this.value) {
					const valueAsString = this.value.toString();
					const match = valueAsString.match(validation);

					isValid = isValid && match !== null && match[0] === valueAsString;
				}
			}

			if (this.minNumber && this.minNumber > this.value) {
				this.errorMessage = this.$t('km_smaller_value_hint', { value: this.minNumber });
				isValid = false;
			}

			this.isValid = isValid;
			this.$emit('validationComplete');
			return this.isValid;
		},
	},
	watch: {
		model: function(oldValue, newValue) {
			if (oldValue !== newValue && newValue && oldValue) {
				this.validate();
			}
		},
		lastValue: function(oldValue, newValue) {
			this.model = this.lastValue.kilometrage;
		},
	},
};
</script>

<style lang="sass" scoped>
.base-input
  height: 43px

.form-group label
  word-break: break-word
</style>
